export default "__VITE_ASSET__IA83M8D4__"